import { HOSTING_URL, REGIONS_URL } from '@/shared/config/systemUrls'

export const buildReceiverHostUrl = (url: string) => {
  if (url === HOSTING_URL || url === REGIONS_URL) {
    if (!url.endsWith('/local')) {
      url += '/local'
    }
  }
  return url
}
